import type { CostValueType } from 'lumen/utils/net-revenue/cost/types';

/**
 * Unit-derived display rules for commission inputs, shared by the simple input
 * and the advanced matrix so the two never drift. Percentages are whole numbers
 * capped at 100; currency amounts allow two decimals and have no upper bound.
 */

export const MAX_PERCENTAGE = 100;

export function stepForUnit(unit: CostValueType): 0.01 | 1 {
  return unit === 'currency' ? 0.01 : 1;
}

export function maxForUnit(unit: CostValueType): number | undefined {
  return unit === 'percentage' ? MAX_PERCENTAGE : undefined;
}

export function placeholderForUnit(unit: CostValueType): string {
  return unit === 'currency' ? '0.00' : '0%';
}
